module.exports = __webpack_public_path__ + "7d917e98eeb15654268c66e061d8ae14.svg";